import Button from "components/ui/Button";
import { useForm } from "react-hook-form";

export default function LogicalPriceEdit({
  initialName,
  initialPercentage,
  initialDescription,
  onSubmit,
}) {
  // Initialize the form with default values
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: initialName || "",
      percentage: initialPercentage || "",
      description: initialDescription || "",
    },
  });

  const submitForm = (data) => {
    console.log("Form submitted:", data);
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(submitForm)} className="space-y-4 p-2">
      {/* Name Field */}
      <div className="space-y-2">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700">
          Name
        </label>
        <input
          type="text"
          id="name"
          {...register("name", { required: true })}
          placeholder="Enter name"
          className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
        />
        {errors.name && <p className="text-red-600 text-sm">Name is required</p>}
      </div>

      {/* Percentage Field */}
      <div className="space-y-2">
        <label htmlFor="percentage" className="block text-sm font-medium text-gray-700">
          Percentage
        </label>
        <div className="relative">
          <input
            type="text"
            id="percentage"
            {...register("percentage", { required: true})}
            placeholder="Enter percentage"
            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm pr-8"
          />
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            %
          </span>
        </div>
        {errors.percentage && (
          <p className="text-red-600 text-sm">Percentage is required and must be a valid number</p>
        )}
      </div>

      {/* Description Field */}
      {/* <div className="space-y-2">
        <label htmlFor="description" className="block text-sm font-medium text-gray-700">
          Description
        </label>
        <textarea
          id="description"
          {...register("description")}
          placeholder="Enter description"
          rows={4}
          className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
        />
      </div> */}

      {/* Submit Button */}
      <Button className="black-button" type="submit">
        Save
      </Button>
    </form>
  );
}
